"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/scp-health-logo-white-text.svg.js",
    _g,
    _defs;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 110,
    height: 68,
    viewBox: "0 0 110 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _g || (_g = React.createElement("g", {
    clipPath: "url(#prefix__clip0_5554_35380)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  }, React.createElement("path", {
    d: "M62.105 1l-6.532 10.45 17.824-.16L79.933 1H62.105zM110 15.514l-9.655 14.42h-14.52l7.269-14.42H110z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14
    },
    __self: this
  }), React.createElement("path", {
    d: "M79.94 1l-6.543 10.29 7.221 16.582 6.764-12.358L79.94 1zM85.924 1l7.15 14.476 16.926.038L100.206 1H85.924z",
    fill: "#B5BD00",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18
    },
    __self: this
  }), React.createElement("path", {
    d: "M11.646 51.824v6.44H3.563v-6.44H1.914v14.568h1.65v-6.68h8.082v6.68h1.65V51.824h-1.65zM16.492 51.824v14.568h9.49v-1.51h-7.84v-5.17h7.472v-1.448H18.14v-4.93h7.84v-1.51h-9.489zM34.003 53.656l3.502 8.134h-6.963l3.461-8.134zm-.794-1.832l-6.415 14.568h1.773l1.383-3.24h8.14l1.385 3.24h1.752l-6.411-14.568h-1.607zM42.617 51.824v14.568h8.511v-1.51h-6.862V51.824h-1.65zM49.558 51.824v1.51h4.318v13.058h1.649V53.334h4.297v-1.51H49.558zM71.755 51.824v6.44H63.67v-6.44H62.02v14.568h1.649v-6.68h8.085v6.68h1.648V51.824h-1.648zM72.358 18.76c-2.365-2.161-5.734-3.305-9.742-3.305h-7.578v31.903h5.319v-7.352h2.259c4.007 0 7.375-1.134 9.74-3.28 2.385-2.167 3.648-5.262 3.648-8.954.005-3.713-1.256-6.829-3.646-9.011zm-12.001 1.703h2.085c5.413 0 8.156 2.46 8.156 7.311 0 4.794-2.743 7.224-8.156 7.224h-2.085V20.463zM22.23 38.825c0 2.701-.996 4.968-2.88 6.556-1.838 1.547-4.445 2.366-7.538 2.366-4.986 0-8.972-2.333-11.227-6.57l-.588-1.106 4.595-2.414.585 1.101c1.351 2.547 3.692 3.949 6.589 3.949 3.227 0 5.146-1.419 5.146-3.796 0-2.313-1.078-3.48-4.808-5.204l-2.386-1.12c-4.63-2.168-7.505-4.449-7.505-9.106 0-4.77 3.71-8.231 8.819-8.231 4.085 0 7.064 1.603 9.107 4.904l.647 1.045-4.277 2.73-.667-1.091c-1.122-1.847-2.55-2.635-4.771-2.635-2.147 0-3.59 1.283-3.59 3.193 0 2.008.952 2.74 4.469 4.388l2.385 1.12c4.875 2.318 7.895 4.786 7.895 9.921zM53.215 40.363l-.787 1.03c-3.22 4.216-7.685 6.354-13.276 6.354-4.484 0-8.607-1.658-11.611-4.668-3.005-3.01-4.623-7.11-4.602-11.588 0-9.26 6.934-16.245 16.127-16.245 5.22 0 9.554 2.063 12.54 5.966l.78 1.021-4.187 3.006-.74-.949c-2.056-2.658-4.894-3.999-8.436-3.999-6.065 0-10.638 4.82-10.638 11.21 0 6.495 4.564 11.21 10.854 11.21 3.726 0 6.833-1.512 8.981-4.372l.726-.973 4.269 2.997z",
    fill: "#fff",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22
    },
    __self: this
  }))), _defs || (_defs = React.createElement("defs", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27
    },
    __self: this
  }, React.createElement("clipPath", {
    id: "prefix__clip0_5554_35380",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28
    },
    __self: this
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h110v68H0z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29
    },
    __self: this
  })))));
}

var _default = ReactComponent;
exports["default"] = _default;